import "../../shared/utils/promiseWithResolversPolyfill";
import * as React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { pdfWorkerSrc } from "../../shared/utils/pdfWorkerSrc";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerSrc(
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`
);

export default function Resume({ url }) {
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [error, setError] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  function onDocumentLoadSuccess({ numPages }) {
    setLoaded(true);
    setNumPages(numPages);
  }

  // Ensure http: is at beginning of url
  if (url && url.slice(0, 6) !== "https:") {
    url = "https:" + url;
  }
  return (
    <>
      {!error && (
        <div
          className={`${loaded ? "content-card mt-4" : ""}`}
          style={{
            opacity: loaded ? 1 : 0,
            height: loaded ? "auto" : 0,
          }}
        >
          <div className="content-card__header">
            <h3><i className="fas fa-file-pdf me-2"></i>Resume</h3>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-modern btn-modern--ghost btn-modern--sm"
            >
              <i className="fas fa-external-link-alt me-1"></i>
              View Full Size
            </a>
          </div>
          <div className="content-card__body text-center">
            <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={() => setError(true)}
            >
              <Page pageNumber={pageNumber} />
            </Document>
            {numPages > 1 && (
              <>
                <p className="mt-3 mb-2 text-muted">
                  Page {pageNumber} of {numPages}
                </p>
                <div className="d-flex justify-content-center gap-2 mb-3" style={{ position: "relative", zIndex: 10 }}>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    style={{ position: "relative", zIndex: 10, pointerEvents: pageNumber <= 1 ? "none" : "auto" }}
                    disabled={pageNumber <= 1}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setPageNumber(pageNumber - 1);
                    }}
                  >
                    <i className="fas fa-chevron-left me-1"></i>
                    Previous
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    style={{ position: "relative", zIndex: 10, pointerEvents: pageNumber >= numPages ? "none" : "auto" }}
                    disabled={pageNumber >= numPages}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setPageNumber(pageNumber + 1);
                    }}
                  >
                    Next
                    <i className="fas fa-chevron-right ms-1"></i>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
